import { render } from "./CalculationTabPage.vue?vue&type=template&id=99bf98b0"
import script from "./CalculationTabPage.vue?vue&type=script&lang=js"
export * from "./CalculationTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__